export enum SKED_PLAN {
  FUNDAMENTALS = "sked-fundamentals",
  FUNDAMENTALS_ANNUAL = "sked-fundamentals-annual",
  ESSENTIALS = "sked-essentials",
  ESSENTIALS_ANNUAL = "sked-essentials-annual",
  PROFESSIONAL = "sked-professional",
  PROFESSIONAL_ANNUAL = "sked-professional-annual",
  ENTERPRISE = "sked-enterprise",
  ENTERPRISE_ANNUAL = "sked-enterprise-annual",
}
